import { LocationIcon } from 'cokitchen-icons';
import { BranchAddressType } from 'models/branch-address.model';
import { LocationObjectType } from 'models/location.model';
import React from 'react';

type Props = {
  address: BranchAddressType;
  isSelected: boolean;
  setSelectedAddress: (address: LocationObjectType) => void;
  number: number;
};
const BranchAddressItem = ({ address, isSelected, setSelectedAddress, number }: Props) => {
  const handleAddressSelect = () => {
    setSelectedAddress({
      id: address.id,
      address: address.address,
      created_at: address.created_at,
      lat: String(address.latitude),
      lng: String(address.longitude),
      name: address.name || 'Branch',
      street_number: '',
      updated_at: address.updated_at
    });
  };
  return (
    <div
      className='w-full flex items-center justify-between gap-3 py-[18px] border-b-[0.8px] border-b-gray-19 cursor-pointer'
      onClick={handleAddressSelect}>
      <div className='flex gap-3 items-center w-[90%] select-none'>
        <LocationIcon />
        <div className='w-[65%]'>
          <p className='text-gray-10 text-sm font-medium capitalize'>
            {address.name || 'Branch'} {number}
          </p>
          <p className='text-gray-12 text-sm line-clamp-1 capitalize'>{address.address}</p>
        </div>
      </div>
      <div className='flex gap-4 justify-between'>
        <span
          className={`ml-auto w-[14px] h-[14px] rounded-full ${
            isSelected ? 'border-[3.8px] border-red-5' : 'border-[1.3px] border-gray-20'
          }`}
        />
      </div>
    </div>
  );
};

export default BranchAddressItem;
